import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchFromAPI } from "../../lib/api";

function ScrollBar() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const data = await fetchFromAPI("/news") || [];
        if (data && Array.isArray(data)) {
          setBlogs(data);
          // console.log(data)
        }
      } catch (error) {
        console.error("Error fetching news updates:", error);
      }
    };

    fetchNews();
  }, []);

  return (
    <div className="fixed bottom-0 left-0 w-full z-[60] bg-stone-900/40 backdrop-blur-xl border-t border-white/5 h-12 flex items-center overflow-hidden">
      <div className="flex items-center h-full px-6 border-r border-white/5 bg-red-600">
        <span className="text-xs tracking-[0.4em] text-white uppercase font-bold">
          Updates
        </span>
      </div>

      <div className="flex-1 overflow-hidden relative h-full flex items-center">
        <div className="flex whitespace-nowrap animate-scroll-gentle">
          {blogs.concat(blogs).map((blog, idx) => (
            <Link
              // to={`/blog/${blog.id || blog._id}`}
              key={`${blog.id || blog._id}-${idx}`}
              className="text-sm font-sans tracking-wide text-white/70 hover:text-amber-400 px-8 transition-colors flex items-center gap-3"
            >
              <span className="w-1.5 h-1.5 bg-red-500 rounded-full shadow-[0_0_10px_rgba(239,68,68,0.8)]" />
              {blog.content}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ScrollBar;